import React from 'react';
import { MessageInputFlat } from 'stream-chat-react';

import './MessagingInput.css';

const MessagingInput: React.FC = () => {
  return (
    <div className="str-chat__messaging-input">
      <MessageInputFlat />
    </div>
  );
};

export default MessagingInput;
